import { render, staticRenderFns } from "./ForwardOrderOrFreeRelease.vue?vue&type=template&id=15c3957c&"
import script from "./ForwardOrderOrFreeRelease.vue?vue&type=script&lang=ts&"
export * from "./ForwardOrderOrFreeRelease.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports